import React from 'react';

import { useTheme } from '@mui/material/styles';
import { Button, Stack, TextField } from 'common/components/material';
import { VoteType } from 'features/matching-engine/matching-engine.utils';

const MIN_INPUT_LENGTH = 4;

export const AddFeedbackText: React.FC<{
  handleSubmit: () => void;
  handleClear: () => void;
  feedbackText: string;
  currentVoteType: VoteType | null;
  onChange: Function;
  isDisabled: boolean;
}> = ({ handleSubmit, handleClear, currentVoteType, feedbackText, onChange, isDisabled }) => {
  const { palette } = useTheme();
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if ((feedbackText ?? '').length >= MIN_INPUT_LENGTH && event.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <Stack direction={'row'} spacing={2} alignItems="center">
      <TextField
        disabled={isDisabled}
        placeholder="Add note..."
        fullWidth
        variant="outlined"
        size="small"
        value={feedbackText}
        onKeyDown={handleKeyDown}
        onChange={(e) => onChange(e.target.value)}
        sx={{
          width: '400px',
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            backgroundColor: isDisabled ? '' : palette.Buttons.Secondary.BgDisabled,
            '&:hover fieldset': {
              borderColor: palette.TextFields.Hover,
            },
            '&.Mui-focused fieldset': {
              borderColor: palette.TextFields.Clicked,
            },
          },
          '& .MuiInputBase-input::placeholder': {
            fontWeight: 400,
            opacity: 0.8,
            fontSize: '0.875rem',
            color: palette.EmptyPlaceholderIcons.IconFill,
          },
        }}
      />
      <Stack direction={'row'} spacing={2}>
        <Button
          size="small"
          onClick={isDisabled ? undefined : handleClear}
          disabled={isDisabled}
        >
          Cancel
        </Button>

        <Button
          disabled={!currentVoteType || isDisabled}
          variant="contained"
          size="small"
          sx={{
            py: 0.25,
          }}
          onClick={isDisabled ? undefined : handleSubmit}
        >
          Save
        </Button>
      </Stack>
    </Stack>
  );
};
